var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":""}},[_c('v-container',[_c('v-toolbar-title',[_c('button',{on:{"click":function($event){return _vm.$router.push("/")}}},[_vm._v("thesegirlz.com")])])],1)],1),_c('v-main',[_c('v-container',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }